import(/* webpackMode: "eager" */ "/app/src/app/terms/page.tsx");
